// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"ca82577e","246":"1d147670","537":"98e2bfa1","554":"39299de0","577":"111d5b8c","625":"fa3a7591","733":"104ab140","742":"c85a1f8e"}[chunkId] + ".chunk.js";
};